// White-label sites share Tripening's ETL, which returns image URLs on www.tripening.com.
// Every site routes /api/product-images/ to the same backend, so point them at the site's own host.
const TRIPENING_IMAGES = 'https://www.tripening.com/api/product-images/'

export function brandImagesPrefix(baseURL?: string): string | null {
    const base = (baseURL || '').replace(/\/$/, '')
    if (!/^https:\/\/[^/]+$/.test(base) || /tripening\.com$/.test(base)) return null
    return `${base}/api/product-images/`
}

// Rewrites matching strings in place (objects/arrays) and returns the result.
export function rebrandImageUrls<T>(data: T, prefix: string | null): T {
    if (!prefix) return data
    const walk = (value: any): any => {
        if (typeof value === 'string') {
            return value.startsWith(TRIPENING_IMAGES) ? prefix + value.slice(TRIPENING_IMAGES.length) : value
        }
        if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) value[i] = walk(value[i])
        } else if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
            for (const key of Object.keys(value)) value[key] = walk(value[key])
        }
        return value
    }
    return walk(data)
}
